import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { routes } from '@/constant/routes.const';
import styled from 'styled-components';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import TextButton from '@/components/common/TextButton';
import ProgressBar from '@/components/common/ProgressBar';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { isNationIncluded } from '@repo/utils';
import { ICON_CHECK_STYLED } from '@repo/assets';
import { BANK_CALL_GUIDE, MAIN_NATIONS } from '@repo/constants';
import { BankCallGuide } from '@repo/components';

function MedicalRefundResult() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { nationality, isCashPickup, isUploadRequired } = useAppSelector(
    (state) => state,
  ) as IGlobalState;

  // const goToRecipt = () => {
  // 	dispatch({ type: 'UPDATE_USER_INFO', payload: { refundAfter: true } });
  // 	history.push(routes.medicalReceipt);
  // };
  const goToHome = () => {
    history.push(routes.medicalHome);
  };

  useEffect(() => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: { isRefundInfoRegistered: true },
    });
  }, []);

  return (
    <ReceiptLayout>
      <Img src={ICON_CHECK_STYLED} />
      <ProgressBar percent={100} />
      <Title>
        {nationality === 'KOR'
          ? `송금 정보 입력이\n완료되었습니다.`
          : `Completed`}
      </Title>
      <Description>
        {(() => {
          if (nationality === 'KOR') {
            return `환급액 지급까지 21일 정도 소요됩니다.`;
          }
          if (isUploadRequired) {
            return 'Please complete uploading your Immigration Documents. Refund processing will begin once all documents are uploaded.';
          }
          if (isCashPickup) {
            return 'Now you can pick up your refund at Western Union after about 21 business days.';
          }
          if (isNationIncluded(MAIN_NATIONS, nationality)) {
            return "We'll send your refunds\nto the information you provided.\nOn average, it takes about 21 business days.";
          }
          return "We'll send an email to request your information\nfor processing refunds within 10 days.\nPlease check your mailbox.";
        })()}
        {(nationality === 'CHN' || nationality === 'JPN') && (
          <BankCallGuide
            title={BANK_CALL_GUIDE[nationality].title}
            questionTitle={BANK_CALL_GUIDE[nationality].questionTitle}
            questionText={BANK_CALL_GUIDE[nationality].questionText}
            answerTitle={BANK_CALL_GUIDE[nationality].answerTitle}
            answerText={BANK_CALL_GUIDE[nationality].answerText}
          />
        )}
      </Description>
      <TextButton
        title={nationality === 'KOR' ? '홈으로' : 'Home'}
        color='#246CF6'
        bgColor='#FFFFFF'
        outline
        onClick={goToHome}
      />
    </ReceiptLayout>
  );
}

export default MedicalRefundResult;

const Img = styled.img`
  width: 66px;
  height: 66px;
  margin: 200px 0 30px;
  transform: translateX(-4px);
`;

const Title = styled.h2`
  font-size: 28px;
  line-height: 36px;
  width: 410px;
  text-align: center;
  white-space: pre-wrap;
  color: #1856cd;
  font-weight: 700;
`;

const Description = styled.p`
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  margin: 12px 0 100px;
  white-space: pre-wrap;
  color: #3a3b3e;
`;

const InfoTitle = styled.span`
  display: block;
  color: #246cf6;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;
